import { Mediaclip } from '../../../interfaces/mediaclip';
import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { BbTableService } from '../../../services/bb-table.service';
import { ModalDefinition, OverlayService } from '../../../services/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { SapiEntity } from '../../../services/sapi.service';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { BbFile, UploadService } from '../../../services/upload.service';
import { Subscription } from 'rxjs';
import { FilterSetService } from '../../../services/filter-set.service';

@Component({
	selector: 'bb-logo-selector',
	templateUrl: './bb-logo-selector.component.html',
	styleUrls: ['./bb-logo-selector.component.scss'],
	providers: [
		BbTableService
	]
})

export class BbLogoSelectorComponent {
	@ViewChild('selectLogoTemplate') selectLogoTemplate: TemplateRef<any>;

	@Output() entityIdChange = new EventEmitter<string>();
	@Output() uploadedEntity = new EventEmitter<boolean>();

	@Input() dropTextRecommendation?: string;
	@Input()
	get entityId() {
		return this._entityId;
	}
	set entityId(entityId: string) {
		if (entityId === undefined) {
			entityId = null;
		}
		if (this.initialValue === undefined) {
			this.initialValue = entityId;
		}
		if (this._entityId !== undefined && this._entityId !== entityId && this.initialValue !== entityId) {
			this.entityIdChange.emit(entityId);
		}
		this._entityId = entityId;
		if (this._entityId) {
			this.mediaclip = {
				id: this._entityId,
				type: 'mediaclip'
			};
			this.hasThumbnails = true;
		} else {
			this.mediaclip = null;
		}
	}

	@Input() mediaTypes: string[];
	@Input() autoPublish: boolean;
	@Input() useType: 'editorial' | 'commercial';
	@Input() showDropZone = false;
	@Input() theme: 'light-v2' | '' = '';

	public mediaclip: SapiEntity;

	selectLogoModel: any;
	selectMediaclipModalDefinition: ModalDefinition;

	thumbnailData: SafeUrl;
	hasThumbnails: boolean;

	uploadServiceSubscription: Subscription;
	private _entityId: string;
	private initialValue: string;

	// @Input() bbTableService: BbTableService;
	constructor(
		public bbTableService: BbTableService,
		private translate: TranslateService,
		private overlayService: OverlayService,
		private uploadService: UploadService,
		private domSanitizer: DomSanitizer,
		private filterSetService: FilterSetService
	) { }

	showLogoSelectModal() {
		this.selectLogoModel = {};

		this.selectMediaclipModalDefinition = {
			icon: 'fa-plug',
			title: this.translate.instant('SELECT_CREATIVE'),
			component: {
				name: 'custom-content',
				class: 'mediaclip-selector',
				templateRef: this.selectLogoTemplate
			}
		};

		this.filterSetService.setFilterSetFromString('');

		this.overlayService.createModal(this.selectMediaclipModalDefinition);
	}

	removeModal() {
		if (this.selectMediaclipModalDefinition) {
			this.overlayService.removeModal(this.selectMediaclipModalDefinition);
		}
	}

	uploadedMediaclipLogo(bbFile: BbFile) {
		if (bbFile) {
			if (this.uploadServiceSubscription) {
				this.uploadServiceSubscription.unsubscribe();
			}
			this.uploadServiceSubscription = this.uploadService.completedObservable.subscribe((file: BbFile) => {
				if (file && bbFile.uploadIdentifier === file.uploadIdentifier) {
					this.uploadedEntity.emit(true);
					this.selectMediaclipLogo(file.mediaclip, file.thumbData.data);
				}
			});
		}
	}

	selectMediaclipLogo(entity: Mediaclip, thumbnailData?: string) {
		if (entity) {
			this.thumbnailData = null;
			if (entity.mediatype === 'video' && entity.hasOwnProperty('thumbnails')) {
				this.hasThumbnails = true;
			} else if (entity.mediatype === 'image') {
				if (thumbnailData) {
					this.thumbnailData = this.domSanitizer.bypassSecurityTrustUrl(thumbnailData);
				}
				this.hasThumbnails = true;
			} else {
				this.hasThumbnails = false;
			}

			this.mediaclip = entity;
			this.entityId = entity.id;
		}
		this.removeModal();
	}

	removeMediaclipLogo() {
		this.mediaclip = null;
		this.entityId = null;
		this.entityIdChange.emit(this.entityId);
	}
}
